import React, {useState, useRef, useEffect} from 'react'
import {DataLink} from '@dv5/domain'
import {InputField} from "../../app/containers/login-register/InputField"
import {DeleteButton} from '../buttons'
import {EditButton} from '../buttons'
import './DataLinkItem.less'

interface DataLinkItemProps {
    dataLink: DataLink
    onNavigate: (dataLink: DataLink) => void
    onDelete: (dataLink: DataLink) => void
    onEdit: (dataLink: DataLink, newTitle: string) => void
}

export const DataLinkItem: React.FC<DataLinkItemProps> = ({
                                                               dataLink,
                                                               onNavigate,
                                                               onDelete,
                                                               onEdit,
                                                           }) => {
    const {id, linkTitle, linkType, externalLinkUrl} = dataLink
    const [isEditing, setIsEditing] = useState(false)
    const [editTitle, setEditTitle] = useState(linkTitle)

    const clickOnLink = (event: React.MouseEvent<HTMLSpanElement>) => {
        event.preventDefault()
        event.stopPropagation()
        onNavigate(dataLink)
    }
    const isExternalLink = (linkType === 'EXTERNAL_LINK' && externalLinkUrl) || externalLinkUrl

    const handleEdit = () => {
        setIsEditing(true)
        setEditTitle(linkTitle)
    }

    const handleSave = () => {
        if (editTitle.trim() && editTitle !== linkTitle) {
            onEdit(dataLink, editTitle.trim())
        }
        setIsEditing(false)
    }

    const handleCancel = () => {
        setIsEditing(false)
        setEditTitle(linkTitle)
    }

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            handleSave()
        } else if (event.key === 'Escape') {
            handleCancel()
        }
    }

    return (
        <div key={id} className="data-link-item">
            {isEditing ? (
                <div onKeyDown={handleKeyDown} onBlur={handleSave} >
                    <InputField
                        id={`edit-${id}`}
                        name="linkTitle"
                        type="text"
                        value={editTitle}
                        onChange={(e) => setEditTitle(e.target.value)}
                        label=""
                        autoFocus
                    />
                </div>
            ) : (
                <span className="data-link-title">{linkTitle}</span>
            )}
            <div className="data-link-meta">
                <span className="data-link-type">{linkType}</span>
                {isExternalLink && (
                    <a
                        href={externalLinkUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="data-link-url"
                    >Navigate</a>
                )}
                {linkType !== 'INTERNAL_LINK' && !isExternalLink && (
                    <span className="data-link-url" onMouseDown={clickOnLink}>Navigate</span>
                )}
                <div className="data-link-actions">
                    {!isEditing && (
                        <EditButton onEdit={handleEdit} />
                    )}
                    <DeleteButton onDelete={() => onDelete(dataLink)} />
                </div>
            </div>
        </div>
    )
}
